/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  WaterDepthFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('waterDepthFilterController',
        [
            '$scope', 'lookupTables',
            function($scope, lookupTables) {
                $scope.componentName = "waterDepthFilter";

                $scope.showCustomRange = false;

                $scope.waterDepth = {
                    shallowest: 1,
                    deepest: 12000
                };

                $scope.waterDepths = [
                    {
                        id: 1,
                        name: "< 500 m",
                        disabled: false,
                        from: $scope.waterDepth.shallowest,
                        to: 500
                    },
                    {
                        id: 2,
                        name: "500 - 1000 m",
                        disabled: false,
                        from: 500,
                        to: 1000
                    },
                    {
                        id: 3,
                        name: "1000 - 2000 m",
                        disabled: false,
                        from: 1000,
                        to: 2000
                    },
                    {
                        id: 4,
                        name: "> 2000 m",
                        disabled: false,
                        from: 2000,
                        to: $scope.waterDepth.deepest
                    },
                    {
                        id: 5,
                        disabled: false,
                        name: "Custom Range"
                    }
                ];


                $scope.resetFilter = function() {
                    $scope.clearWaterDepthSelections();
                };

                $scope.clearWaterDepthSelections = function() {
                    $scope.selectedWaterDepthId = 5;
                    delete $scope.criteria["waterDepthFrom"];
                    delete $scope.criteria["waterDepthTo"];
                };

                $scope.removeWaterDepthFilter = function() {
                    $scope.resetFilter();
                    $scope.$parent.removeFilter("#waterDepthFilter");
                };

                $scope.initialiseFilter = function() {
                    // determine if the range in use conforms to one of the 
                    // established ranges

                    if ($scope.criteria.waterDepthFrom === $scope.waterDepth.shallowest &&
                        $scope.criteria.waterDepthTo === 500) {
                        $scope.selectedWaterDepth = $scope.waterDepths[0];
                        $scope.showCustomRange = false;

                    } else if ($scope.criteria.waterDepthFrom === 500 && $scope.criteria.waterDepthTo === 1000) {
                        $scope.selectedWaterDepth = $scope.waterDepths[1];
                        $scope.showCustomRange = false;

                    } else if ($scope.criteria.waterDepthFrom === 1000 && $scope.criteria.waterDepthTo === 2000) {
                        $scope.selectedWaterDepth = $scope.waterDepths[2];
                        $scope.showCustomRange = false;

                    } else if ($scope.criteria.waterDepthFrom === 2000 &&
                        $scope.criteria.waterDepthTo === $scope.waterDepth.deepest) {
                        $scope.selectedWaterDepth = $scope.waterDepths[3];
                        $scope.showCustomRange = false;

                    } else {
                        $scope.selectedWaterDepth = $scope.waterDepths[4];
                        $scope.showCustomRange = true;
                    }

                };


                $scope.$watch("selectedWaterDepth", function (oldValue, newValue) {
                    if (!$scope.selectedWaterDepth) { // || 
                        $scope.selectedWaterDepth = $scope.waterDepths[4];
                    }

                    // this is a hack because the value of $scope.selectedWaterDepth
                    // seems to experience a 'wobble'
                    if ($scope.selectedWaterDepth.length === 0) return;

                    $scope.showCustomRange = ($scope.selectedWaterDepth.id === 5);

                    if (!$scope.showCustomRange) {
                        $scope.criteria.waterDepthFrom = $scope.selectedWaterDepth.from;
                        $scope.criteria.waterDepthTo = $scope.selectedWaterDepth.to;

                        $scope.criteria.selectedWaterDepthId = $scope.selectedWaterDepth.id;
                    }
                });

                $scope.initialiseFilter();
            }
        ])
    .directive('waterDepthFilter',
        [
            '$compile',
            function($compile) {
                return {
                    replace: true, // replace the placeholder element with the template
                    restrict: 'A', // usage: <div projectNameFilter />
                    templateUrl: "../app-ds3/search/queryBuilder/filters/waterDepthFilter.tmpl.html",
                    link: function($scope, iElement, iAttrs) {
                    },

                    controller: 'waterDepthFilterController'
                };
            }
        ]);
//------------------------------------------------------------------------
